// Composable para manejar la lista de colores recientes de etiquetas en localStorage.
// Persistido por cuenta para no mezclar con otros workspaces.
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const MAX_RECENTS = 10;

export function useRecentLabelColors() {
  const store = useStore();
  const accountId = computed(() => store.getters.getCurrentAccountId);
  const key = computed(() => `victorpos:recent-label-colors:${accountId.value}`);
  const list = ref([]);

  function load() {
    try {
      const raw = localStorage.getItem(key.value);
      const parsed = raw ? JSON.parse(raw) : [];
      list.value = Array.isArray(parsed) ? parsed.filter(c => typeof c === 'string') : [];
    } catch (e) {
      list.value = [];
    }
  }

  function add(hex) {
    if (!hex || typeof hex !== 'string') return;
    const normalized = hex.toLowerCase();
    const next = [normalized, ...list.value.filter(c => c.toLowerCase() !== normalized)].slice(0, MAX_RECENTS);
    list.value = next;
    try {
      localStorage.setItem(key.value, JSON.stringify(next));
    } catch (e) { /* ignore quota errors */ }
  }

  load();
  return { list, add, load };
}
